<template>
  <div>
    <div class="text-green" style="margin-bottom: 10px;">
      Enter multiple IP ranges, one per line. Examples for IP Ranges are as follows:

          <li>10.20.108.9 - 10.20.108.255</li>
          <li>10.20.30.* - 10.20.80.*</li>
          <li>10.20.30.*</li>

    </div>
    <textarea class="form-control" rows="10" placeholder="Enter IP Ranges"></textarea>
  </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/paywall/sessions/sections/IpRange.vue